import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {DomSanitizer} from '@angular/platform-browser';
import {UniversityRankingService} from '../../../shared/services/university-ranking.service';
import {UniversityService} from '../../../shared/services/university.service';
import {UtilsService} from '../../../shared/services/utils.service';
import {environment} from '../../../../environments/environment';

interface OverviewEditorBlock {
    type: 'content' | 'table';
    value: string;
}

@Component({
    selector: 'app-university-ranking',
    templateUrl: './university-ranking.component.html',
    styleUrls: ['./university-ranking.component.scss']
})
export class UniversityRankingComponent implements OnInit {
    public toggleMenu = false;
    private _unsubscribeAll: Subject<any>;
    public universityId: any;
    submitting: any = false;
    submitted: any = false;
    dataExists: any = false;
    university: any;
    editorBlocks: OverviewEditorBlock[] = [{type: 'content', value: ''}];
    tinymceApiKey = environment.tinymceApiKey;

    tableEditorInit = {
        menubar: false,
        branding: false,
        plugins: 'lists link autolink charmap media searchreplace visualblocks wordcount codesample table',
        toolbar: 'undo redo | bold italic underline | bullist numlist | link media charmap | ' +
            'table tableinsertrowbefore tableinsertrowafter tabledeleterow tableinsertcolbefore tableinsertcolafter tabledeletecol | removeformat'
    };

    constructor(private sanitizer: DomSanitizer,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private universityRankingService: UniversityRankingService,
                private universityService: UniversityService) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.universityId = this.activatedRoute.snapshot.parent.params['id'];
        this.refresh();
    }

    refresh() {
        this.getUniversityDetail();
        this.universityRankingService.detailByAdmin(this.universityId).subscribe(data => {
            this.dataExists = !!(data && data['description']);
            const blocks = (data && data['description']) ? UtilsService.splitEditorBlocks(data['description']) : [];
            if (data && data['table_html']) {
                blocks.push({type: 'table', value: data['table_html']});
            }
            this.editorBlocks = blocks.length ? blocks : [{type: 'content', value: ''}];
        });
    }

    getUniversityDetail() {
        this.universityService.detail(this.universityId).subscribe(data => {
            if (data) {
                this.university = data;
            }
        });
    }

    addEditorBlock(editor: 'content' | 'table') {
        this.editorBlocks.push({type: editor, value: ''});
    }

    removeEditorBlock(index: number) {
        this.editorBlocks.splice(index, 1);
    }

    submit() {
        this.submitting = true;
        const description = UtilsService.joinEditorBlocks(this.editorBlocks);
        const params = {
            'description': description ? UtilsService.encodeHtml(description) : '',
            'table_html': ''
        };
        if (this.dataExists) {
            this.universityRankingService.updateByAdmin(this.universityId, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
            }, error => {
                this.submitting = false;
                this.submitted = false;
            });
        } else {
            this.universityRankingService.createByAdmin(this.universityId, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.dataExists = true;
            }, error => {
                this.submitting = false;
                this.submitted = false;
            });
        }
    }

    goTo(tab) {
        this.router.navigateByUrl('university/' + this.universityId + '/' + tab);
    }
}
